import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
// import { TabPanel, TabView } from 'primereact/tabview';

import { Dropdown } from 'primereact/dropdown';
import {
  FinanceCouncil,
  PrequalificationCouncil,
  SpecializationCouncil,
} from 'features/Council/pages';
import { ReviseProjectProposalDetail } from 'features/ReviseProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import { AbilityContext } from 'components/Can';
import TimeLine from 'features/ReviseProjectProposal/components/TimeLine';

function ReviewTheProposalPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'ViewDetail';

  const [selectedType, setSelectedType] = useState('ViewDetail');
  const types = [
    { name: t('projectProposal.viewDetail.labelTab0'), code: 'ViewDetail' },
    { name: t('projectProposal.viewDetail.labelTab1'), code: 'Prequalification' },
    { name: t('projectProposal.viewDetail.labelTab2'), code: 'Specialization' },
    { name: t('projectProposal.viewDetail.labelTab3'), code: 'Finance' },
  ];

  useEffect(() => {
    setSelectedType(type);
  }, [type]);

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TimeLine />

        <div
          style={{
            overflowY: 'auto',
            borderRadius: '12px',
            border: '1px solid var(--surface-border)',
            backgroundColor: 'white',
            flex: 1,
          }}
        >
          {ability.can('read', 'project_proposal') ? (
            <>
              <div className="flex justify-content-end pt-3 pr-3">
                <Dropdown
                  options={types}
                  optionLabel="name"
                  optionValue="code"
                  onChange={(e) => navigate(`.?type=${e.value}`)}
                  value={selectedType}
                  className="w-full md:w-16rem text-right"
                />
              </div>
              {(selectedType === null || selectedType === 'ViewDetail') && (
                <ReviseProjectProposalDetail />
              )}
              {selectedType === 'Prequalification' &&
                ability.can('read_prequalification', 'council') && <PrequalificationCouncil />}
              {selectedType === 'Specialization' && ability.can('read', 'council') && (
                <SpecializationCouncil />
              )}
              {selectedType === 'Finance' && ability.can('read', 'council') && <FinanceCouncil />}
            </>
          ) : (
            <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
          )}
          <ScrollTop target="parent" />
        </div>
      </Layout>
    </LayoutProvider>
  );
}

export default ReviewTheProposalPage;
